import { Paper } from "@mui/material";
import ForeCasterTable from "./ForeCasterTable";

const ForeCasterTableCard = () => {
  return (
    <Paper sx={{ padding: "16px 16px 0px 16px" }}>
      <ForeCasterTable />
    </Paper>
  );
};

export default ForeCasterTableCard;
